const Loading = ({ title = '', subtitle = '' } = {}) => `
  <div class="loading flex flex-1 flex-column">
    <div class="loading__header margin-xl">
      <h1>${title}</h1>
    </div>
    <div class="loading__image-container-search margin-xl">
      <div class="spinner outer">
        <div class="spinner inner"></div>
      </div>
      <p class="margin-lg text-lighter">${subtitle}</p>
    </div>
  </div>
`;

export default Loading;
